import { render } from "./PostExamScreen.vue?vue&type=template&id=c3a23238"
import script from "./PostExamScreen.vue?vue&type=script&lang=js"
export * from "./PostExamScreen.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/dash/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__